/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_Ai_HeadingInputs */



/**
* | output |
* | --- |
* | "How experienced are you with AI?" |
*
* @param {Onboarding_Step_Ai_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_ai_heading = /** @type {((inputs?: Onboarding_Step_Ai_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_Ai_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie erfahren bist du mit KI?")
	return /** @type {LocalizedString} */ ("How experienced are you with AI?")
});